// t7-1b (T4) y t7-1c (P, #479): LOS GRUPOS DEL ALUMNO EN SU PANEL, UNA TARJETA
// PLEGABLE POR GRUPO, QUE ES UNA TARJETA DE DOCUMENTO.
//
// ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).
//
// Anexo A (#479): la tarjeta del grupo es exactamente una tarjeta de documento de
// hoy. Por eso es la MISMA pareja movil y escritorio de `TarjetaDeCard` (que a su
// vez la tiene del Panel), con sus cadenas de clases copiadas letra por letra: el
// contenedor de cada gemela (con el cursor y el tacto de la tarjeta lista), el
// renglon, la caja del icono, el nombre recortado a un renglon, el contenedor de la
// linea de informacion y su texto. `GruposDelAlumno.test.js` lee los dos fuentes y
// compara lo pintado contra una `TarjetaDeCard` pieza por pieza.
//
// Lo que cambia, y solo eso:
//   - en la caja del icono, el icono de grupo (mismo tamano y color que el de
//     documento en cada gemela);
//   - la linea de informacion dice "N cards" (texto 22; N = las cards del grupo,
//     activas y caducadas) o, sin cards, el texto 3. Sin chip;
//   - el renglon de esa linea lleva un ALTO MINIMO igual al del chip "Listo"
//     (`ALTO_DEL_CHIP`): sin chip, el renglon mediria lo que mide una linea de
//     texto (15 px en movil, 16.5 desde md) y la tarjeta del grupo saldria 6 y 4.5
//     px mas baja que la tarjeta propia de al lado. No se pinta nada nuevo: es un
//     minimo, y el texto queda centrado en el renglon como queda junto al chip;
//   - en el hueco del bote (con sus mismas utilidades de tamano, `HUECO_MOVIL` y
//     `HUECO_ESCRITORIO`) va la flecha: un boton con `aria-expanded` y los textos 4
//     y 5, que gira al abrir. Su clic no sube al cuadro, para no abrir y cerrar de
//     un solo toque.
// Toda la tarjeta abre y cierra: el cuadro de cada gemela escucha el clic.
//
// ABIERTA: las cards de estudio van DENTRO del cuadro, debajo de la cabecera, mas
// angostas (el acolchado del cuadro) y con una guia vertical a la izquierda, del
// color del borde tenue del Panel (`GUIA_DE_LAS_CARDS`). Como el cuadro es una
// pareja, dentro de la gemela movil va solo la gemela movil de cada card, y dentro
// de la de escritorio solo la de escritorio (`TarjetaDeCard` con `gemela`): asi no
// hay cuatro nodos por card ni marcas repetidas. El toque en una card (y en el
// hueco entre cards) se queda ahi: no pliega el grupo. Las cards van en el orden
// del servidor (activas arriba, lo mas reciente primero; caducadas hasta abajo).
//
// El pliegue vive SOLO en memoria: nace cerrado en cada montaje. Una recarga del
// material (mismo grupo, datos nuevos) no lo cierra: el estado cuelga del id.
//
// Sin grupos devuelve `null`, no un contenedor vacio: el Panel queda identico.
//
// series-7 (C.6, #491, 24-sep-2026): ABIERTA, arriba de las cards y dentro de la
// guia, el cuadro "Buscar por nombre" y el selector de orden (`BuscadorEnTarjeta`).
// El orden de omision es el de hoy (el del servidor); "A-Z" y "Z-A" ordenan por el
// nombre mostrado sin distinguir acentos, y las caducadas siguen hasta abajo,
// ordenadas igual entre ellas. El texto filtra por contenido, sin mayusculas ni
// acentos. Sin resultados, el texto C14. Los dos controles viven en memoria, como el
// pliegue, y los comparten las dos gemelas. Plegada no cambia nada.
// remates-1-3-0c (Bloque Q7): el selector de orden se fue ("borra el filtro que es de
// lista; el de la caja de texto no lo borres"). Queda el cuadro, a todo lo ancho, y el
// orden de hoy por omision: el del servidor.
//
// series-7 (#482, 24-sep-2026): con el grupo ABIERTO, al posarse o apretar una card
// se ilumina solo esa card, no el cuadro. Las cadenas de clases NO se tocan (las
// fija GruposDelAlumno.test.js por igualdad): el cuadro de cada gemela lleva la
// marca `data-cuadro-plegable` y la guia de adentro `data-guia-plegable`, y
// `index.css` devuelve el cuadro a su reposo mientras la guia esta bajo el puntero
// o apretada (la prueba es hover482.test.js). Sin `:has()` (iOS menor a 15.4) queda
// la conducta de antes.
//
// ── dashboard-rediseno (15-oct-2026): "GRUPO (GROUP) PLEGABLE" (4.6, firma 3 y bloque C) ───────
// LAPIDA de lo de arriba: el grupo ya no es una tarjeta de documento con la flecha en el hueco
// del bote. Ocupa todo el ancho de la rejilla del Panel (`A_LO_ANCHO`):
//   - CERRADO: una fila (fondo #141414, borde #222222, radio 18) con el icono de personas de 44,
//     el nombre (16 px seminegrita) y debajo "Group, 5 cards" (`dashboard:panel.grupo_cards`). El
//     boton "Show 5 cards" con su flecha va a la derecha desde 768 (40 px) y debajo del nombre, a
//     lo ancho, en el telefono (44 px).
//   - ABIERTO: el boton dice "Hide cards" y la flecha gira; debajo, el buscador de hoy a lo ancho
//     (44 px; 16 px de letra en el telefono) y las publicaciones en su rejilla (3, 2 o 1 columnas).
//   - C1 (sin publicaciones): sin boton; debajo del nombre "Group" (`dashboard:panel.grupo_solo`)
//     y abajo un recuadro punteado con "Your professor hasn't published anything yet." (el de hoy).
// En codigo y textos nada dice "salon" ni "class". Toda la fila abre y cierra; el pliegue vive
// en memoria (nace cerrado); el buscador conserva su conducta (#491, #501, F1).
import React, { useState } from 'react';
import { ChevronDown, Users } from 'lucide-react';
import TarjetaDeCard, {
  CURSOR_DE_LISTA, HUECO_MOVIL, HUECO_ESCRITORIO, CAJA_DEL_ICONO_MOVIL, CAJA_DEL_ICONO_ESCRITORIO,
} from './TarjetaDeCard';
import BuscadorEnTarjeta from './BuscadorEnTarjeta';
import { filtrarPorNombreOTema, resumenDeTemas } from '../lib/buscarPorTema';
import { A_LO_ANCHO, REJILLA_INTERNA, BOTON_PIE_SECUNDARIO } from './panel/anatomia';

// LAPIDA dashboard-rediseno: el alto del chip "Listo" y la guia vertical de las cards de adentro
// ya no se usan en el Panel; las cadenas se quedan exportadas para quien las leia.
export const ALTO_DEL_CHIP = 'min-h-[21px]';
export const GUIA_DE_LAS_CARDS = 'mt-3 pl-2 border-l-2 border-[#333333]';
export { CURSOR_DE_LISTA, HUECO_MOVIL, HUECO_ESCRITORIO, CAJA_DEL_ICONO_MOVIL, CAJA_DEL_ICONO_ESCRITORIO };

// La fila del grupo, cerrada o abierta.
export const FILA_DEL_GRUPO = 'rounded-[18px] border border-[#222222] bg-[#141414] p-4';

// La marca de #482 se queda en la fila: la regla de `index.css` le pone a ese cuadro el reposo de
// la tarjeta de cristal mientras se posa o se aprieta lo de adentro. La fila nueva no cambia al
// posarse, asi que su fondo y su borde van en linea (una regla de hoja no le gana a un estilo en
// linea) y la regla no la mueve.
const COLORES_DE_LA_FILA = { backgroundColor: '#141414', borderColor: '#222222' };

// Un clic que se queda donde nacio (no sube a la fila del grupo).
const quieto = (e) => e.stopPropagation();

const nombreDeCard = (card) => card.nombre;
const temasDeCard = (card) => (Array.isArray(card.temas) ? card.temas.map((t) => t && t.nombre).filter(Boolean) : []);

function TarjetaDeGrupo({ grupo, t, idioma, entregaDeCard, alReintentar, preparacion }) {
  const [abierta, setAbierta] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const cards = Array.isArray(grupo.cards) ? grupo.cards : [];
  const sinCards = cards.length === 0;
  const visibles = filtrarPorNombreOTema(cards, busqueda, nombreDeCard, temasDeCard);
  const alternar = () => {
    if (sinCards) return;
    if (abierta) setBusqueda('');
    setAbierta(!abierta);
  };
  const linea = sinCards ? t('dashboard:panel.grupo_solo') : t('dashboard:panel.grupo_cards', { count: cards.length });

  const boton = (sufijo, ancho) => (
    <button
      type="button"
      onClick={(e) => { quieto(e); alternar(); }}
      aria-expanded={abierta}
      className={`${BOTON_PIE_SECUNDARIO}${ancho ? ' w-full h-11' : ''}`}
      data-testid={`grupo-${grupo.id}-toggle${sufijo}`}
    >
      {abierta ? t('dashboard:panel.ocultar_cards') : t('dashboard:panel.ver_cards', { count: cards.length })}
      <ChevronDown className={`w-4 h-4 transition-transform ${abierta ? 'rotate-180' : ''}`} aria-hidden="true" />
    </button>
  );

  const fila = (gemela, sufijo) => {
    const movil = gemela === 'movil';
    return (
      <div onClick={alternar} className={`${FILA_DEL_GRUPO}${sinCards ? '' : ' cursor-pointer'}`} style={COLORES_DE_LA_FILA}
        data-cuadro-plegable="" data-testid={`grupo-${grupo.id}${sufijo}`}>
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-[#1C130D] flex items-center justify-center shrink-0">
            <Users className="w-5 h-5 text-[#F7A06A]" aria-hidden="true" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-[16px] leading-[22px] font-semibold text-[#F4F4F3] truncate" data-testid={`grupo-${grupo.id}-nombre${sufijo}`}>{grupo.nombre}</p>
            <p className="text-[13px] leading-[18px] text-[#9A9A9A] truncate" data-testid={`grupo-${grupo.id}-linea${sufijo}`}>{linea}</p>
          </div>
          {!sinCards && !movil ? boton(sufijo, false) : null}
        </div>
        {!sinCards && movil ? <div className="mt-3">{boton(sufijo, true)}</div> : null}
        {sinCards ? (
          <p className="mt-3 rounded-xl border border-dashed border-[#2C2C2C] px-4 py-3 text-[13px] leading-[18px] text-[#9A9A9A] text-center"
            data-testid={`grupo-${grupo.id}-vacio${sufijo}`}>
            {t('dashboard:grupos_alumno.sin_publicaciones')}
          </p>
        ) : null}
        {abierta && !sinCards ? (
          <div className="mt-4" onClick={quieto} data-guia-plegable="" data-testid={`grupo-${grupo.id}-cards${sufijo}`}>
            <BuscadorEnTarjeta t={t} valor={busqueda} alCambiar={setBusqueda} testid={`grupo-${grupo.id}-buscar${sufijo}`} alto={44} tocable44 />
            <div className="mt-3">
              {visibles.length === 0 ? (
                <p className="text-[13px] text-[#9A9A9A] leading-snug py-2" data-testid={`grupo-${grupo.id}-nada${sufijo}`}>
                  {t('dashboard:tarjeta_plegable.nada_coincide')}
                </p>
              ) : (
                <div className={REJILLA_INTERNA}>
                  {visibles.map(({ item: card, temas }) => (
                    <TarjetaDeCard key={card.id} card={card} t={t} idioma={idioma} gemela={gemela}
                      temaCoincidente={temas ? resumenDeTemas(temas) : null} cuantosTemas={temas ? temas.length : 0}
                      entrega={entregaDeCard ? entregaDeCard(card) : null} alReintentar={alReintentar}
                      preparacion={preparacion ? preparacion[card.id] : undefined} />
                  ))}
                </div>
              )}
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  return (
    <div className={A_LO_ANCHO} data-celda={`g:${grupo.id}`}>
      <div className="md:hidden">{fila('movil', '-mobile')}</div>
      <div className="hidden md:block">{fila('escritorio', '')}</div>
    </div>
  );
}

// t7-3 (A3, #558): `entregaDeCard(card)` y `alReintentar(card)` solo los pasa el Panel de la
// APP. dashboard-rediseno: `preparacion` es `{publicacion_id: valor}` (la Preparacion de cada
// publicacion, la misma de Analiticas).
export default function GruposDelAlumno({ grupos, t, idioma, entregaDeCard = null, alReintentar = null, preparacion = null }) {
  if (!Array.isArray(grupos) || grupos.length === 0) return null;
  return (
    <>
      {grupos.map((grupo) => (
        <TarjetaDeGrupo key={grupo.id} grupo={grupo} t={t} idioma={idioma}
          entregaDeCard={entregaDeCard} alReintentar={alReintentar} preparacion={preparacion} />
      ))}
    </>
  );
}
